import React from 'react';
interface WordCappedTextareaProps {
  label: string;
  name: string;
  placeholder?: string;
  value: string;
  error?: string;
  maxWords?: number;
  onChange: (value: string) => void;
}
export function countWords(value: string): number {
  const trimmed = value.trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
}
export function WordCappedTextarea({
  label,
  name,
  placeholder,
  value,
  error,
  maxWords = 100,
  onChange
}: WordCappedTextareaProps) {
  const words = countWords(value);
  const atCap = words >= maxWords;
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const next = event.target.value;
    if (countWords(next) <= maxWords) {
      onChange(next);
      return;
    }
    // Hard cap: keep only the first maxWords words
    onChange(next.trim().split(/\s+/).slice(0, maxWords).join(' '));
  };
  return <div className="flex flex-col space-y-2" data-id="element-99" data-mp="gkggpt3xgq3v">
      <label htmlFor={name} className="text-sm font-medium text-engage-gray5" data-id="element-100" data-mp="li888m0nua7j">
        {label}
      </label>
      <textarea id={name} name={name} placeholder={placeholder} value={value} onChange={handleChange} aria-describedby={`${name}-count`} className={`w-full bg-engage-gray2 border rounded-sm px-4 py-3 text-engage-white placeholder-engage-gray4 focus:outline-none focus:border-engage-yellow focus:ring-1 focus:ring-engage-yellow transition-colors duration-200 min-h-[120px] resize-y ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-engage-gray3'}`} data-id="element-101" data-mp="2us5yfu7it6ff" />
      <div className="flex items-start justify-between gap-4" data-id="element-102" data-mp="3nfa0bqbbh4mz">
        {error ? <span className="text-sm text-red-500" data-id="element-103" data-mp="3iijjv1vlo711">{error}</span> : <span data-id="element-104" data-mp="bdk2jtjddpk" />}
        <span id={`${name}-count`} aria-live="polite" className={`text-xs shrink-0 tabular-nums ${atCap ? 'text-engage-yellow font-semibold' : 'text-engage-gray4'}`} data-id="element-105" data-mp="cop0mypwri9">
          {words} / {maxWords} words
        </span>
      </div>
    </div>;
}